module.exports = __webpack_public_path__ + "img/13-04_Improving Processes.78207ac9.svg";